module.exports = __webpack_public_path__ + "assets/img/48@3x.9dd60915.png";